var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.313%",
    y1: "100%",
    x2: "84.687%",
    y2: "0%",
    id: "artists"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E646B6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6666",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 23.67c-.636-.46-.798-1.112-.485-1.958l2.36-7.256H1.308a1.34 1.34 0 01-1.126-.614c-.244-.379-.244-.998 0-1.377L7.334.613C7.547.233 7.974 0 8.46 0h10.226c.457 0 .883.234 1.126.613.244.38.213.876-.03 1.255l-4.991 7.649h3.201c.548 0 1.004.32 1.217.788.183.467.061.992-.304 1.343L6.25 23.493c-.274.263-1.396.866-2.35.177zm-.88-11.117h3.886c.426 0 1.007-.053 1.285.525.222.324.222.74 0 1.25l-2.094 6.026a.2.2 0 00.33.207l8.8-8.797a.2.2 0 00-.142-.341h-1.61 0c-.457 0-.963.13-1.405-.468-.442-.598-.243-1.174 0-1.554l5.115-7.419a.2.2 0 00-.164-.313l-7.67-.001a.3.3 0 00-.258.146L2.85 12.25a.2.2 0 00.172.303z",
    transform: "translate(1 1)",
    fill: "url(#artists)",
    fillRule: "nonzero",
    stroke: "url(#b)",
    strokeWidth: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtist);
export default __webpack_public_path__ + "static/media/artist.735bae931d0f652add2fc84258aa2081.svg";
export { ForwardRef as ReactComponent };